import { DataValidationEnvironmentalData } from '@/types'
import {
  faCloud,
  faTemperatureHigh,
  faTemperatureLow,
  faUmbrella,
  faWind,
  faStopwatch20,
  faSmog,
  faClock,
  faCity,
} from '@fortawesome/free-solid-svg-icons'
import { Stack } from '@mui/material'
import { EnvironmentDataItem } from './EnvironmentDataItem'
import {
  FOG_LEVEL_DICHTE_MIST,
  FOG_LEVEL_MIST_BOVEN_WATERGANGEN,
} from '@/constants'

export const EnvironmentData = ({
  start_temperature,
  end_temperature,
  urban_heat_temperature,
  cloud_cover,
  wind_force,
  precipitation,
  precipitation_duration,
  fog_level,
  fog_duration,
}: DataValidationEnvironmentalData): JSX.Element => (
  <Stack direction="column" spacing={3}>
    <Stack direction="row" spacing={8}>
      <EnvironmentDataItem
        iconName={faTemperatureLow}
        field={start_temperature}
        fieldLocalization="temperature-start"
      />
      <EnvironmentDataItem
        iconName={faTemperatureHigh}
        field={end_temperature}
        fieldLocalization="temperature-end"
      />
      <EnvironmentDataItem
        iconName={faCity}
        field={urban_heat_temperature ?? { value: null, has_error: false }}
        fieldLocalization="temperature-urban-heat"
      />
      <EnvironmentDataItem
        iconName={faWind}
        field={wind_force}
        fieldLocalization="windSpeed"
      />
      <EnvironmentDataItem
        iconName={faCloud}
        field={cloud_cover}
        fieldLocalization="cloudCover"
      />
      <EnvironmentDataItem
        iconName={faUmbrella}
        field={precipitation}
        fieldLocalization="rain"
      />
      <EnvironmentDataItem
        iconName={faStopwatch20}
        field={precipitation_duration}
        fieldLocalization="rain-duration"
      />
    </Stack>
    <Stack direction="row" spacing={8}>
      <EnvironmentDataItem
        iconName={faSmog}
        field={fog_level}
        fieldLocalization="fogLevel"
      />
      {(fog_level.value === FOG_LEVEL_DICHTE_MIST ||
        fog_level.value === FOG_LEVEL_MIST_BOVEN_WATERGANGEN) && (
        <EnvironmentDataItem
          iconName={faClock}
          field={fog_duration}
          fieldLocalization="fog-duration"
        />
      )}
    </Stack>
  </Stack>
)
